import createManualEntityChoice from './createManualEntityChoice';

const withManualClientChoice = createManualEntityChoice({
  manualId: 'ponctuel',
  resource: 'companies',
  searchFilter: { user_kind: 'client' },
  activeFieldName: 'manual_client_active',
  manualChoiceLabelKey:
    'resource.invoices.field.client_company_id.choices.manual_client.label',
  fieldLabelKey: 'resource.invoices.field.client_company_id.label',
  getOptionLabel: (item) =>
    item.name || item.corporate_name || item.name_or_leader_full_name,
  onSelectReal: async (val, form, dataProvider, t) => {
    try {
      const { data: company } = await dataProvider.getOne('companies', {
        id: val,
      });

      let legal = company?.legal_information;
      if (!legal && company?.legal_information_id) {
        const { data } = await dataProvider.getOne('legal_informations', {
          id: company.legal_information_id,
        });
        legal = data;
      }

      if (legal || company) {
        const corporateName =
          legal?.corporate_name || legal?.name || company?.name || '';
        const billingStreet =
          legal?.billing_street ||
          legal?.street ||
          company?.location?.address ||
          '';
        const billingZipcode =
          legal?.billing_zipcode ||
          legal?.zipcode ||
          company?.location?.postal_code ||
          '';
        const billingCity =
          legal?.billing_city || legal?.city || company?.location?.city || '';
        const billingCountry = (
          legal?.billing_country ||
          legal?.country ||
          company?.location?.country ||
          ''
        ).toUpperCase();

        form.change('corporate_name', corporateName);
        form.change('billing_mail', legal?.billing_mail || '');
        form.change('billing_street', billingStreet);
        form.change('billing_zipcode', billingZipcode);
        form.change('billing_city', billingCity);
        form.change('billing_country', billingCountry);
        form.change('vat_number', legal?.vat_number?.toString() || '');

        // Conditions de paiement
        form.change('days_delayed', legal?.days_delayed ?? 30);
        form.change('end_month', legal?.end_month ?? false);
        form.change(
          'payment_terms',
          legal?.payment_terms ||
            t('resource.invoices.field.payment_terms.default_value')
        );
        form.change('precise_date', legal?.precise_date ?? null);
      }
    } catch (e) {
      console.error('Failed to pre-fill client information', e);
    }
  },
  onSelectManual: (form, t) => {
    form.change('corporate_name', '');
    form.change('days_delayed', 30);
    form.change('end_month', false);
    form.change(
      'payment_terms',
      t('resource.invoices.field.payment_terms.default_value')
    );
    [
      'billing_mail',
      'billing_street',
      'billing_zipcode',
      'billing_city',
      'billing_country',
      'vat_number',
    ].forEach((f) => form.change(f, ''));
  },
});

export default withManualClientChoice;
